import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { setEventDetail, setEventDetailModalStatus } from '../../../../../redux/features/shared/sharedSlice';
import moment from 'moment';

const EventDetail = () => {
    const dispatch: any = useDispatch();
    const sharedActions: any = useSelector((state: any) => state.sharedActions);

    const closeModal = () => {
        dispatch(setEventDetailModalStatus(false))
        dispatch(setEventDetail({}))
    }
    return (
        <Modal backdrop="static" size='lg' show={sharedActions.eventModal} onHide={closeModal} animation={true}>
            <Modal.Header closeButton>
                <Modal.Title>Event</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span className='fw-bold'>Room</span> : {sharedActions?.eventDetail?.room?.roomName}
                </div>
                <div>
                    <span className='fw-bold'>Date & Time</span>: {moment(sharedActions?.eventDetail?.date).format("DD/MM/YYYY")} {sharedActions?.eventDetail?.time}
                </div>
                <div>
                    <span className='fw-bold'>Event Duration</span>: {sharedActions?.eventDetail?.eventDuration}
                </div>
                <div>
                    <span className='fw-bold'>Time Duration</span>: {sharedActions?.eventDetail?.timeDuration}
                </div>
                <div>
                    <span className='fw-bold'>Event Type</span>: {sharedActions?.eventDetail?.eventType}
                </div>
                <div>
                    <span className='fw-bold'>Price</span>: {sharedActions?.eventDetail?.price} $
                </div>
                <div>
                    <div className='mt-2'>
                        <h6>Description</h6>
                    </div>
                    <div>
                        {sharedActions?.eventDetail?.description}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default EventDetail